export default __webpack_public_path__ + "static/media/place.3f0d491d.svg";